/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadClaimedByFacility
 */
export interface LeadClaimedByFacility {
    /**
     * 
     * @type {string}
     * @memberof LeadClaimedByFacility
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadClaimedByFacility
     */
    id?: string;
}

/**
 * Check if a given object implements the LeadClaimedByFacility interface.
 */
export function instanceOfLeadClaimedByFacility(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LeadClaimedByFacilityFromJSON(json: any): LeadClaimedByFacility {
    return LeadClaimedByFacilityFromJSONTyped(json, false);
}

export function LeadClaimedByFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadClaimedByFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function LeadClaimedByFacilityToJSON(value?: LeadClaimedByFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}

